(function() {
  'use strict';

  angular
    .module('admin.explore.customset.service', [])
    .factory('ExploreCustomSetService', ExploreCustomSetService);

  /** @ngInject */
  function ExploreCustomSetService($http, $q, API) {

    function list(t, start, limit){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/set_lists?t=' + t + '&start=' + start + '&limit=' + limit + '&sort=id-desc')
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listAll(){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/set_lists')
          .success(defered.resolve)
          .error(defered.reject);

        return defered.promise;
    }

    function listSlss(id, start, limit){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/set_lists/' + id + '/slss?start=' + start + '&limit=' + limit + '&sort=n-asc')
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function get(id){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/set_lists/' + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function create(model){
      var defered = $q.defer();

      $http.post(API.API_URL + 'admin/set_lists', model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function createSlss(id, model){
      var defered = $q.defer();

      $http.post(API.API_URL + 'admin/set_lists/' + id + '/slss', model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function update(id, model){
      var defered = $q.defer();

      $http.put(API.API_URL + 'admin/set_lists/' + id, model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function updateSlss(parentId, id, model){
      var defered = $q.defer();

      $http.put(API.API_URL + 'admin/set_lists/' + parentId + '/slss/' + id, model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function remove(id){
      var defered = $q.defer();

      $http.delete(API.API_URL + 'admin/set_lists/' + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function removeSlss(parentId, id){
      var defered = $q.defer();

      $http.delete(API.API_URL + 'admin/set_lists/' + parentId + '/slss/' + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return{
       list: list,
       listAll: listAll,
       listSlss: listSlss,
       get: get,
       create: create,
       createSlss: createSlss,
       updateSlss: updateSlss,
       update: update,
       remove: remove,
       removeSlss: removeSlss,
    };

  }

})();
